class DiscountCode extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleSubmit = this.handleSubmit.bind(this)

    if (this?.els?.form?.exists && this?.els?.submit?.exists) {
      this.els.form.elements.forEach(formEl => {
        this.listeners.add(formEl, 'submit', this.handleSubmit)
      })
    }
  }

  async handleSubmit (event) {
    event.preventDefault()
    const formData = new FormData(event.target)
    const discountCode = formData.get('discount')

    const currentCodes = this.els.input.element.dataset.current || ''
    const discountCodes = currentCodes
      ? `${discountCode},${currentCodes}`
      : discountCode

    const state = await window.BAO.Cart.updateCartDiscount(discountCodes)

    if (state) {
      this.els.input.element.value = ''
    }
  }

  handleResponse (code) {
    this.ariaInvalid = !code.applicable

    if (code.applicable === true) {
      if (this.els.submit?.element) {
        const appliedText = this.els.submit.element.dataset.applied
        const applyText = this.els.submit.element.dataset.apply

        this.els.submit.element.textContent = appliedText
        this.els.submit.element.disabled = true

        setTimeout(() => {
          this.els.submit.element.textContent = applyText
          this.els.submit.element.disabled = false
        }, 2000)
      }

      if (this.els.error?.element) {
        this.els.error.element.setAttribute('aria-hidden', 'true')
      }
    } else {
      if (this.els.error?.element) {
        this.els.error.element.setAttribute('aria-hidden', 'false')
      }
    }
  }
}

if (!customElements.get('discount-code')) {
  customElements.define('discount-code', DiscountCode)
}
